import { Experiment } from "@otta/search/constants/experiments";
import { useExperiment } from "@otta/search/hooks/unleash";

export function useHasNewLogo(): boolean {
  return useExperiment(Experiment.OttaWttjRebranding)?.variant === "wave2";
}
